// Fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	fa1,
	fa2,
	fa3,
	fa4,
	fa5,
	faAngleRight,
	faArrowDown,
	faArrowDownLong,
	faArrowDownShortWide,
	faArrowDownWideShort,
	faArrowLeft,
	faArrowRight,
	faArrowRotateLeft,
	faArrowRotateRight,
	faArrowsRotate,
	faArrowsUpDownLeftRight,
	faArrowUpLong,
	faArrowUpRightFromSquare,
	faBars,
	faBell,
	faBookAtlas,
	faBookmark,
	faBookOpenReader,
	faBullhorn,
	faCalculator,
	faCalendarDays,
	faChartArea,
	faChartLine,
	faChartPie,
	faCheck,
	faChevronDown,
	faAnglesDown,
	faAnglesUp,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faCircleCheck,
	faCircleChevronDown,
	faCircleExclamation,
	faCircleInfo,
	faCirclePlus,
	faCircleQuestion,
	faCircleXmark,
	faClipboard,
	faClipboardCheck,
	faClock,
	faClockRotateLeft,
	faCloud,
	faCloudBolt,
	faCloudRain,
	faCloudShowersHeavy,
	faCloudSun,
	faCommentDots,
	faCopy,
	faDatabase,
	faDeleteLeft,
	faDesktop,
	faDownload,
	faDroplet,
	faEllipsis,
	faEnvelope,
	faEnvelopeOpen,
	faExclamationTriangle,
	faEye,
	faFileArrowUp,
	faFileExcel,
	faFileLines,
	faFilter,
	faFlagCheckered,
	faFloppyDisk,
	faForwardFast,
	faGauge,
	faGaugeSimpleHigh,
	faGear,
	faGears,
	faGlassWaterDroplet,
	faHand,
	faHardDrive,
	faHashtag,
	faHourglassHalf,
	faHouse,
	faInfo,
	faKey,
	faListUl,
	faLocationArrow,
	faLocationDot,
	faLock,
	faLockOpen,
	faMagnifyingGlass,
	faMagnifyingGlassChart,
	faMagnifyingGlassMinus,
	faMagnifyingGlassPlus,
	faMapLocationDot,
	faMicrochip,
	faMinus,
	faPaperclip,
	faPaperPlane,
	faPencil,
	faPhone,
	faPlus,
	faPlusMinus,
	faQuestion,
	faReceipt,
	faRightFromBracket,
	faRoadBarrier,
	faScrewdriverWrench,
	faShoePrints,
	faSitemap,
	faSliders,
	faSmog,
	faSnowflake,
	faSort,
	faSortDown,
	faSortUp,
	faSpinner,
	faSun,
	faSuperscript,
	faTableCells,
	faTag,
	faTemperatureHalf,
	faTrash,
	faTriangleExclamation,
	faUser,
	faUserPlus,
	faUsersBetweenLines,
	faUsersGear,
	faVial,
	faWarehouse,
	faWaveSquare,
	faWind,
	faWrench,
	faXmark,
	faBuilding,
	faImage,
	faPen,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";

import {
	barWidgetIndicator,
	dragNDrop,
	faAddReportTemplate,
	faArrowRightOverDot,
	faCalculatorPlate,
	faCIO,
	faController,
	faCustomLanguage,
	faDeviceAndVariableSelection,
	faDisinfection,
	faDownloadReport,
	faEditReportTemplate,
	faGraphCompare,
	faLevelSensor,
	faManageReport,
	faNavReport,
	faNumeric,
	faOnboardCreateReport,
	faOnboardDeviceSelection,
	faOnboardReportDownload,
	faOnboardReportParams,
	faOnboardReportRequestProcess,
	faPump,
	faReportRequestParams,
	faSensor,
	faVirtualDevice,
} from "./customIcons";

export const fontBundle =
{
	faPhone,
	faEllipsis,
	faChevronDown,
	faAnglesDown,
	faAnglesUp,
	faSort,
	faSortDown,
	faSortUp,
	faTriangleExclamation,
	faCircleXmark,
	faChevronLeft,
	faChevronUp,
	faCircleChevronDown,
	faArrowDownLong,
	faArrowUpLong,
	faArrowDownShortWide,
	faArrowDownWideShort,
	faCircle,
	faCirclePlus,
	faMagnifyingGlassChart,
	faXmark,
	faFilter,
	faGear,
	faMapLocationDot,
	faLocationDot,
	faFileLines,
	faArrowRotateLeft,
	faArrowRotateRight,
	faMagnifyingGlassMinus,
	faMagnifyingGlassPlus,
	faArrowsUpDownLeftRight,
	faMagnifyingGlass,
	faArrowRight,
	faArrowLeft,
	faPencil,
	faFloppyDisk,
	faPlus,
	faSpinner,
	faTrash,
	faMinus,
	faGears,
	faSliders,
	faClipboardCheck,
	faVial,
	faGlassWaterDroplet,
	faCircleExclamation,
	faCheck,
	faDeleteLeft,
	faCircleInfo,
	faDroplet,
	faWarehouse,
	faBullhorn,
	faUser,
	faRightFromBracket,
	faEnvelopeOpen,
	faEnvelope,
	faHardDrive,
	faClipboard,
	faArrowDown,
	faGauge,
	faChartLine,
	faHashtag,
	faBell,
	faPaperPlane,
	faHouse,
	faKey,
	faUserPlus,
	faBars,
	faArrowUpRightFromSquare,
	faBookmark,
	faTag,
	faWrench,
	faShoePrints,
	faForwardFast,
	faAngleRight,
	faChartArea,
	faCalendarDays,
	faDownload,
	faTableCells,
	faFileExcel,
	faGraphCompare,
	faExclamationTriangle,
	faArrowsRotate,
	faCircleCheck,
	faCopy,
	faQuestion,
	faGaugeSimpleHigh,
	faWind,
	faBookAtlas,
	faPlusMinus,
	faArrowRightOverDot,
	faCircleQuestion,
	faCustomLanguage,
	faDatabase,
	faTemperatureHalf,
	faCloud,
	faNumeric,
	faListUl,
	faLocationArrow,
	barWidgetIndicator,
	faSun,
	faCloudSun,
	faCloudBolt,
	faCloudRain,
	faCloudShowersHeavy,
	faSnowflake,
	faSmog,
	faPaperclip,
	faEye,
	faCommentDots,
	faChevronRight,
	faClockRotateLeft,
	faChartPie,
	faWaveSquare,
	dragNDrop,
	faMicrochip,
	faCalculator,
	faCalculatorPlate,
	faVirtualDevice,
	faFlagCheckered,
	faCIO,
	faController,
	faPump,
	faDisinfection,
	faSensor,
	faLevelSensor,
	faDesktop,
	faInfo,
	faBookOpenReader,
	faReceipt,
	faSuperscript,
	faRoadBarrier,
	faNavReport,
	faManageReport,
	faDownloadReport,
	faEditReportTemplate,
	faAddReportTemplate,
	faDeviceAndVariableSelection,
	faReportRequestParams,
	faOnboardCreateReport,
	faOnboardDeviceSelection,
	faOnboardReportParams,
	faOnboardReportRequestProcess,
	faOnboardReportDownload,
	faSitemap,
	faLock,
	faLockOpen,
	faUsersGear,
	faUsersBetweenLines,
	faHourglassHalf,
	fa1,
	fa2,
	fa3,
	fa4,
	fa5,
	faScrewdriverWrench,
	faHand,
	faClock,
	faFileArrowUp,
	faBuilding,
	faImage,
	faPen,
  faUserCheck,
};

library.add(
	// for custom icons we need to forcefully extend the "IconName" type
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	//@ts-ignore
	fontBundle
);

export { FontAwesomeIcon as fontawesome } from "@fortawesome/vue-fontawesome";
